const AllProductData = (productData) => {
  const finalProductsData = [];

  Object.keys(productData).forEach((item) => {
    finalProductsData.push(productData[item]);
  });
  return finalProductsData;
};

const AllJohnsAdvtData = (zhAdvData) => {
  const finalJohnsAdv = {
  };

  const newIndexData = zhAdvData;

  Object.keys(newIndexData).forEach((item) => {
    finalJohnsAdv[item] = newIndexData[item];
  });

  return finalJohnsAdv;
};

export const finalClassic2Products = AllProductData(window.classic2Products || {});
export const finalReal2Products = AllProductData(window.real2Products || {});
export const finalGift1Products = AllProductData(window.gift1Products || {});
export const finalProduct = AllProductData(window.product || {});
export const finalZhNoodlesAdvData = AllJohnsAdvtData(window.zhNoodlesAdv || {});
export const finalZhSauceAdvData = AllJohnsAdvtData(window.zhSauceAdv || {});
export const finalZhEvaluateAdvData = AllJohnsAdvtData(window.zhEvaluateAdv || {});
export const finalJohnsHomeAdvData = AllJohnsAdvtData(window.johnsHomeAdv || {});
